import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hack'
})
@Injectable()
export class hackPipe implements PipeTransform {

  transform(obj) {
    return Object.keys(obj).map(function (key) { return obj[key]; });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pipes/hack.ts